<h2 mat-dialog-title>{{ data.compliant }}</h2>
<mat-dialog-content>
  <ul [ngSwitch]="data.compliant">
    <ng-container *ngSwitchCase="'Não Conforme'">
      @for (item of data.results; track item.label) {
        <li style="color: #777; font-style: italic">
          {{ item.label }}
        </li>
      }
    </ng-container>

    <ng-container *ngSwitchCase="'Conforme com Ressalvas'">
      @for (item of data.results; track item.label) {
        <li style="color: #777; font-style: italic">
          {{ item.label }}
        </li>
      }
    </ng-container>

    <ng-container *ngSwitchCase="'Conforme'">
      <span style="color: #777; font-style: italic"
        >Todos os critérios estão em conformidade.</span
      >
    </ng-container>

    <ng-container *ngSwitchCase="'Em Análise'">
      <span style="color: #777; font-style: italic"
        >Verificando conformidade</span
      >
    </ng-container>

    <ng-container *ngSwitchCase="'Não Analisado'">
      <span *ngIf="data.observation; else semObservacao">
        {{ data.observation }}
      </span>

      <ng-template #semObservacao>
        <span style="color: #777; font-style: italic">
          Sem observações registradas.
        </span>
      </ng-template>
    </ng-container>
  </ul>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton mat-dialog-close>Fechar</button>
</mat-dialog-actions>
